import { HttpService } from './http-service'
import { AuthService } from '../auth/AuthService'
import { ClientConfig } from '../config/ClientConfig'

export const PokerTableService = new (class {
	async authenticateWithTableServer(tableAuthUrl: string): Promise<string> {
		const playerId = await AuthService.getCurrentUserId()
		const url = `${tableAuthUrl}/player/v1/auth/${playerId}`

		const response = await HttpService.post<TableAuthTokenResponse>(url, {}, { authenticate: true })

		return response.token
	}

	async getTableInfo(tableId: string): Promise<TableInstanceInfoResponse> {
		const url = `${ClientConfig.POKER_TABLE_GATEWAY_URL}/player/v1/table-info/${tableId}`
		return await HttpService.get<TableInstanceInfoResponse>(url, {authenticate: true})
	}
})()

interface TableAuthTokenResponse {
	token: string
}

interface TableInstanceInfoResponse {
	tableId: string,
	tableAuthUrl: string,
	tableSocketUrl: string,
	tableServerInstanceId: string,
}
